import { render } from "./DocumentView.vue?vue&type=template&id=58b648fa"
import script from "./DocumentView.vue?vue&type=script&lang=js"
export * from "./DocumentView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__